define('Cart.Detailed.View.Stock.Status', [
    'Cart.Detailed.View',
    'underscore'
], function CartDetailedViewStockStatus(
    CartDetailedView,
    _
) {
    'use strict';

    _.extend(CartDetailedView.prototype, {
        getContext: _.wrap(CartDetailedView.prototype.getContext, function parse(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            var findOutofStock = _.some(ret.model.get('lines').models, function findStock(line) {
                var isPickupLine = line.getOption('custcol_bopis_store_location') &&
                    line.getOption('custcol_bopis_store_location').get('value') &&
                    line.getOption('custcol_bopis_store_location').get('value').internalid;

                return line.get('stockStatusId') === '4' && !isPickupLine;
            });

            ret.nonStock = findOutofStock;

            return ret;
        })
    });
});

